import { useFormContext } from '../../Context';
import UploadFileInput from './UploadFileInput';
import EditableInput from 'Components/Weaver/Input/EditableInput';
import Json5Vars from './Json5Vars';
import { Form } from 'antd';

export default function TaskForm({ form, ...props }) {
  const { formValues, updateFormValues } = useFormContext();
  const initialValues = formValues?.config;

  const properties = formValues.header?.functionality?.configDefinition?.properties || {};
  const relevantProperties = Object.entries(properties).filter(
    ([key, configProps]) => key === 'file' || configProps.subType === 'json5-with-vars'
  );

  return (
    <div className="task-form">
      <Form
        form={form}
        initialValues={initialValues}
        onValuesChange={(vals) => updateFormValues({ config: { ...formValues.config, ...vals } })}
      >
        {relevantProperties.length > 0 ? (
          relevantProperties.map(([key, configProps]) => {
            if (key === 'file') {
              return (
                <Form.Item label={_.startCase(key)} name={key} key={key}>
                  <UploadFileInput
                    field={key}
                    form={form}
                    onFileSelect={(val) => updateFormValues({ config: { ...formValues.config, ...val } })}
                    {...configProps}
                  />
                </Form.Item>
              );
            } else if (configProps.subType === 'json5-with-vars' && !_.isEmpty(formValues.config[key])) {
              return (
                <Json5Vars
                  field={key}
                  form={form}
                  value={formValues.config[key]}
                  {...configProps}
                />
              );
            } else if (configProps.subType === 'json5-with-vars' && _.isEmpty(formValues.config[key])) {
              return <></>;
            } else {
              return (
                <Form.Item label={_.startCase(key)} name={key} key={key}>
                  <EditableInput form={form} {...configProps} />
                </Form.Item>
              );
            }
          })
        ) : (
          <div className="empty">
            <h3>Please select a functionality from the Header form.</h3>
          </div>
        )}
      </Form>
    </div>
  );
}